import React from 'react';
export function Footer() {
  return <footer className="bg-surface border-t border-border py-12" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-51">
          <div className="text-center md:text-left" data-id="element-52">
            <span className="font-heading text-2xl text-accent-yellow tracking-wider" data-id="element-53">
              SSS
            </span>
            <p className="text-muted text-sm mt-2" data-id="element-54">
              © {new Date().getFullYear()} Social Survival Script. All rights
              reserved.
            </p>
          </div>

          <div className="flex gap-6 text-sm text-muted" data-id="element-55">
            <a href="#" className="hover:text-primary transition-colors" data-id="element-56">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary transition-colors" data-id="element-57">
              Terms of Service
            </a>
            <a href="#" className="hover:text-primary transition-colors" data-id="element-58">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </footer>;
}